export const getFullLocalUrl = (absolutePath: string) => {
    const params = new URLSearchParams(document.location.search.substring(1))
    const env = params.get("env")

    if (env === "2") {
        return `https://menyweb.trumffrontend.systest.trumf.cloud${absolutePath}`
    } else if (env === "3") {
        return `https://meny.no${absolutePath}`
    }
    return `https://${window.location.host}${absolutePath}`
}
